import React, { useContext, useEffect, useState } from 'react';
import {
  BusFareDepartContext,
  BusFareReturnContext,
  CurrencyContext,
  CurrentCurrencyContext,
  HealthCareAddOnContext,
  InsuranceAddonContext,
  VoucherDiscountContext,
  ValueMealAddonContext,
} from '../UserContext';
import './BusFareSubTotal.css';
import {
  checkIsReschedule,
  getMonetaryUnitText,
  getSelectedAddOnData,
  getToken,
  sessionStorageGetItem,
  sessionStorageSetItem,
} from './Function';
import axios from 'axios';

export const BusFareSubTotal = ({
  page,
  bus_fare_price,
  loyalty_discount_amount,
  activities_price,
  ground_transport_price = 0,
}) => {
  const addOnData = getSelectedAddOnData();
  // let {BusFareAddOn, setBusFareAddOn} = useContext(BusFareAddOnContext);
  const { BusFareDepart, setBusFareDepart } = useContext(BusFareDepartContext);
  const { BusFareReturn, setBusFareReturn } = useContext(BusFareReturnContext);
  const { VoucherDiscount, setVoucherDiscount } = useContext(
    VoucherDiscountContext,
  );
  const { insuranceAddOn, setInsuranceAddOn } = useContext(
    InsuranceAddonContext,
  );

  const { healthCareAddOn, setHealthCareAddOn } = useContext(
    HealthCareAddOnContext,
  );

  const { currentCurrency, setCurrentCurrency } = useContext(
    CurrentCurrencyContext,
  );

  const { valueMealAddon, setValueMealAddOn } = useContext(
    ValueMealAddonContext,
  );

  const { exchangeCurrency, setExchangeCurrency } = useContext(CurrencyContext);

  const monetaryUnit = getMonetaryUnitText(currentCurrency);

  const sessionInsurance = sessionStorageGetItem('insuranceAddOn');
  const sessionHealthCare = sessionStorageGetItem('healthCareAddOn');
  const sessionValueMeal = sessionStorageGetItem('valueMealAddOn');

  const departBusFare = JSON.parse(sessionStorageGetItem('departBusFare'));
  const returnBusFare = JSON.parse(sessionStorageGetItem('returnBusFare'));
  // const { selectedDepartSeat, setDepartSeat } = useContext(SelectSeatDepartContext);
  const checkReschedule = checkIsReschedule();

  // console.log(`selectedDepartSeat=${selectedDepartSeat}`);
  let selected_depart_seat = JSON.parse(
    sessionStorageGetItem('selectedDepartSeat'),
  );
  const depart_data_multi_modal = JSON.parse(
    sessionStorageGetItem('departDataMultiModal'),
  );

  const departDataMultiModal = JSON.parse(
    sessionStorageGetItem('departDataMultiModal'),
  );

  const shuttleFee = Number(
    (departDataMultiModal
      ? currentCurrency === 'MYR'
        ? departDataMultiModal.fare
        : departDataMultiModal.adultPriceInSgd || 0
      : 0
    ).toFixed(2),
  );

  const BusFareAddOn = JSON.parse(sessionStorageGetItem('addOn'));
  let TotalBusFare =
    (currentCurrency === 'MYR' ? departBusFare.fare : departBusFare.sgdFare) +
    (currentCurrency === 'MYR'
      ? returnBusFare?.fare || 0
      : returnBusFare?.sgdFare || 0) +
    shuttleFee;

  if (page == 'payment') {
    TotalBusFare = parseInt(sessionStorageGetItem('busFare'));
    loyalty_discount_amount = JSON.parse(sessionStorageGetItem('loyalty'));
    // console.log(TotalBusFare);
  } else {
    sessionStorageSetItem('loyalty', JSON.stringify(loyalty_discount_amount));
  }
  // console.log(BusFareAddOn)
  let total_addOn =
    0 +
    (insuranceAddOn?.fee || JSON.parse(sessionInsurance)?.fee || 0) /
      (currentCurrency === 'MYR' ? 1 : exchangeCurrency.addOnCurrency) +
    (healthCareAddOn?.fee || JSON.parse(sessionHealthCare)?.fee || 0) /
      (currentCurrency === 'MYR' ? 1 : exchangeCurrency.addOnCurrency) +
    (valueMealAddon?.fee || JSON.parse(sessionValueMeal)?.fee || 0) /
      (currentCurrency === 'MYR' ? 1 : exchangeCurrency.addOnCurrency);

  if (addOnData != null && addOnData.length != 0) {
    addOnData.forEach((element) => {
      total_addOn +=
        currentCurrency === 'MYR'
          ? Number(element.totalamtinmyr)
          : Number(element.totalamtinsgd || 0);
      // element.details.forEach((sub) => {
      //   if (sub.subtotal != '') {
      //     total_addOn += parseFloat(sub.subtotal);
      //   }
      //   // console.log("--------------")
      //   // console.log(sub.qty)
      //   // console.log(sub.subtotal)
      //   // console.log(total_addOn)
      // });
    });
  } else if (checkReschedule == true) {
    var origin_data = sessionStorageGetItem('Origin_data');
    if (origin_data != null) {
      origin_data = JSON.parse(origin_data);
    }
    if (origin_data.AddOnData != null && origin_data.AddOnData.length != 0) {
      origin_data.AddOnData.forEach((element) => {
        element.forEach((el) => {
          total_addOn += parseFloat(el.totalamt);
        });
      });
    }
  }
  // console.log(total_addOn)
  // console.log(BusFareAddOn)
  if (VoucherDiscount > TotalBusFare) {
    setVoucherDiscount(TotalBusFare);
    sessionStorageSetItem('voucherDiscountAmount', TotalBusFare);
  }

  return (
    <>
      <div>
        <div className='bus-fare-sub-total'>
          <table className='subTotal_table' width={'100%'}>
            {depart_data_multi_modal && (
              <tr>
                <td>
                  <h6>Shuttle Bus</h6>
                </td>
                {/* <td><h3>RM {(depart_data_multi_modal.fare * selected_depart_seat.length).toFixed(2)}</h3></td> */}
                <td>
                  <h3>FREE</h3>
                </td>
              </tr>
            )}

            <tr>
              <td>
                <h6>Bus Fare</h6>
              </td>
              <td>
                <h3>
                  {monetaryUnit} {checkReschedule ? 0 : TotalBusFare.toFixed(2)}
                </h3>
              </td>
            </tr>

            {checkReschedule ? (
              <tr>
                <td>
                  <h6>Admin Charge</h6>
                </td>
                <td>
                  <h3>
                    {monetaryUnit}{' '}
                    {(
                      Number(
                        JSON.parse(sessionStorageGetItem('rescheduleAmount')),
                      ) /
                      (currentCurrency === 'MYR'
                        ? 1
                        : exchangeCurrency.busFareCurrency)
                    ).toFixed(2)}
                  </h3>
                </td>
              </tr>
            ) : (
              ''
            )}
            {loyalty_discount_amount != 0 ? (
              <tr>
                <td className='SubTotal_loyaltyDiscount'>
                  <h6>- Loyalty Discount</h6>
                </td>
                <td className='SubTotal_loyaltyDiscount'>
                  <h3>
                    -{monetaryUnit}{' '}
                    {(
                      Number(loyalty_discount_amount) /
                      (currentCurrency === 'MYR'
                        ? 1
                        : exchangeCurrency.busFareCurrency)
                    ).toFixed(2)}
                  </h3>
                </td>
              </tr>
            ) : (
              ''
            )}
            {VoucherDiscount != 0 ? (
              <tr>
                <td className='SubTotal_loyaltyDiscount'>
                  <h6>- Promo Code Discount</h6>
                </td>
                <td className='SubTotal_loyaltyDiscount'>
                  <h3>
                    -{monetaryUnit}{' '}
                    {(
                      Number(VoucherDiscount) /
                      (currentCurrency === 'MYR'
                        ? 1
                        : exchangeCurrency.busFareCurrency)
                    ).toFixed(2)}
                  </h3>
                </td>
              </tr>
            ) : (
              ''
            )}

            {total_addOn != 0 ? (
              <tr>
                <td>
                  <h6>Activities</h6>
                </td>
                <td>
                  <h3>
                    {monetaryUnit} {total_addOn.toFixed(2)}
                  </h3>
                </td>
              </tr>
            ) : (
              ''
            )}
            {/* {ground_transport_price != null ? (
                        <tr>
                            <td><h6>Ground Transport</h6></td>
                            <td><h3>RM 0</h3></td>
                        </tr>
                        ) : ("")} */}
          </table>
        </div>
      </div>
    </>
  );
};
